import { memo } from 'react';

// Skeleton para o banner do módulo (desktop e mobile)
export const ModuleBannerSkeleton = memo(() => {
    return (
        <div className="card card-flag rounded-5 w-100 overflow-hidden mb-4 border-none position-relative">
            <div className="position-relative" style={{ height: '300px', backgroundColor: '#e9ecef' }}>
                <div className="position-absolute w-100 h-100" style={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}></div>
                <div className="skeleton-shimmer"></div>
                <div className="card-img-overlay d-flex flex-column justify-content-between">
                    <div className="text-white text-center my-auto">
                        <div style={{ width: '60%', height: '24px', backgroundColor: 'rgba(255,255,255,0.3)', borderRadius: '4px', margin: '0 auto', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                    <div className="d-flex flex-column d-md-none align-items-center gap-2">
                        <div style={{ width: '90%', height: '38px', backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: '50rem', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                        <div style={{ width: '90%', height: '38px', backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: '50rem', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                    <div className="d-none d-md-flex flex-row flex-wrap justify-content-start align-items-start gap-2">
                        <div style={{ width: '150px', height: '38px', backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: '50rem', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                        <div style={{ width: '150px', height: '38px', backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: '50rem', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

ModuleBannerSkeleton.displayName = 'ModuleBannerSkeleton';

// Skeleton para card de aula
const AulaCardSkeleton = memo(() => {
    return (
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-4 mt-2">
            <div className="card-body mt-3 shadow-sm rounded-4 p-3" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
                {/* Cabeçalho do Card */}
                <div className="d-flex flex-column mb-3">
                    <div className="card-title">
                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ width: '60px', height: '24px', backgroundColor: '#e9ecef', borderRadius: '50rem', position: 'relative' }}>
                                <div className="skeleton-shimmer"></div>
                            </div>
                            <div style={{ width: '70%', height: '20px', backgroundColor: '#e9ecef', borderRadius: '4px', position: 'relative' }}>
                                <div className="skeleton-shimmer"></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Área de Ações */}
                <div className="d-flex flex-wrap align-items-center gap-2">
                    <div className="d-flex flex-wrap gap-2 ms-auto">
                        <div className="btn btn-sm" style={{ width: '80px', height: '32px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                        <div className="btn btn-sm" style={{ width: '80px', height: '32px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

AulaCardSkeleton.displayName = 'AulaCardSkeleton';

// Componente que renderiza múltiplos skeletons de aulas
export const AulaSkeletons = ({ count = 6 }) => {
    const skeletons = Array.from({ length: count }, (_, index) => (
        <AulaCardSkeleton key={`skeleton-aula-${index}`} />
    ));

    return <>{skeletons}</>;
};

export default AulaSkeletons;
